<template>
    <div class="tooltip-wrapper">
        <slot></slot>
        <template v-if="text || html">
            <feather
                :id="uuid"
                :type="type"
                :size="size"
                :class="{'ml-1': $slots.default, [`text-${iconVariant}`]: iconVariant}"
                class="flex-shrink-0"
            />
            <b-tooltip
                :target="uuid"
                :boundary="boundary || 'body'"
                :variant="variant"
                :show="show"
                :placement="placement"
                :fallback-placement="['flip']"
                :custom-class="`tooltip-width-${width} ${customClass}`"
            >
                <div v-if="html" v-html="html"></div>
                <template v-else>{{ text }}</template>
            </b-tooltip>
        </template>
    </div>
</template>



<script>
    import { generateId } from '@/utils/util';

    export default {
        name: 'Tooltip',
        props: {
            variant: {
                type: String,
                default: undefined,
            },
            iconVariant: {
                type: String,
                default: undefined,
            },
            size: {
                type: Number,
                default: 18,
            },
            type: {
                type: String,
                default: 'help-circle',
            },
            html: {
                type: String,
                default: null,
            },
            text: {
                type: String,
                default: null,
            },
            placement: {
                type: String,
                default: undefined,
            },
            width: {
                type: Number,
                default: 300,
                validator: value => [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000].includes(value),
            },
            customClass: {
                type: String,
                default: null,
            },
            show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                uuid: generateId(),
                boundary: document.querySelector('#wrapper'),
            };
        },
    };
</script>



<style lang="scss" scoped>
    .tooltip-wrapper {
        display: inline-flex;
        line-height: 1;
        align-items: center;

        ::v-deep {
            i.feather {
                /* color: $brand; */
                margin-top: auto;
                margin-bottom: auto;
            }
        }
    }
</style>
